export default __webpack_public_path__ + "static/media/pg-17.87ac490d.jpg";